export default __webpack_public_path__ + "static/media/scikit-learn-icon.33b7ab3a.svg";